import MovedStars from "components/Common/EffectElement/MovedStars";
import styled from "styled-components";
import useSectionAnimation from "./hooks/useSectionAnimation";
import SectionTitle from "./SectionTitle";
import textShadow from "styles/shadow";
import { Link } from "react-router-dom";

const ContactLayout = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  padding: 0 var(--side-padding);
  padding-bottom: var(--side-padding);
  display: flex;
  flex-direction: column;
`;

const ContactBox = styled.div`
  position: relative;
  z-index: 2;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5%;

  h2 {
    font-size: 4.8rem;
    letter-spacing: 2px;
    font-family: "Dhurjati", sans-serif;
    text-transform: uppercase;
    font-weight: 600;
    ${textShadow(3)}
  }

  ul {
    padding: 2rem 0;
    text-align: center;
  }
  li {
    font-size: 2.2rem;
    margin-bottom: 1.6rem;
    font-weight: 600;
    font-family: "Poppins";
  }

  .naver,
  .google {
    position: relative;
    padding-bottom: 1rem;
    letter-spacing: 1px;
  }
  h2 {
    position: relative;
  }
  h2::after {
    position: absolute;
    content: "";
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    background-color: #17b75e;
  }

  .blog li {
    text-transform: uppercase;
  }

  .github {
    height: 3rem;
    display: flex;
    align-items: center;
    gap: 1rem;
  }
  .blog li:hover {
    transform: scale(1.1);
  }

  .github::before {
    content: " ";
    display: inline-block;
    background: url("/assets/img/git.png");
    background-size: cover;
    width: 2.4rem;
    height: 2.4rem;
  }
`;

export default function Contact() {
  const animationState = useSectionAnimation(5);

  if (animationState === "animation-deactive") return <div></div>;
  return (
    <ContactLayout>
      <MovedStars zIndex={1} />
      <SectionTitle title="Contact" />
      <ContactBox>
        <h2>E-mail</h2>
        <ul className="e-mail">
          <li className="naver">dnrgus1127@naver.com</li>
          <li className="google">dnrgus1127@gmail.com</li>
        </ul>
        <h2>Blog</h2>
        <ul className="blog">
          <li className="github">
            <Link to={"https://github.com/dnrgus1127/TIL"}>Github TIL</Link>
          </li>
          <li className="velog">
            <Link to={"https://velog.io/@dnrgus1127/posts"}>Velog.io</Link>
          </li>
        </ul>
      </ContactBox>
    </ContactLayout>
  );
}
